/*** IMPORTS FROM imports-loader ***/
(function() {
var define = false;

'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _components = require('components');

var SearchMenu = (function (_React$Component) {
	_inherits(SearchMenu, _React$Component);

	function SearchMenu(props) {
		var _this = this;

		_classCallCheck(this, SearchMenu);

		_React$Component.call(this, props);

		this.onDocumentClick = function (event) {
			var toggle = _reactDom2['default'].findDOMNode(_this.refs.toggle);
			var menu = _reactDom2['default'].findDOMNode(_this.refs.menu);

			if (toggle && toggle.contains(event.target)) {
				event.preventDefault();
				_this.setState({ 'isOpen': !_this.state.isOpen });

				// if (this.state.isOpen) ReactDOM.findDOMNode(this.refs.searchInput).focus();
			} else if (menu && !menu.contains(event.target)) {
					_this.setState({ 'isOpen': false });
				}
		};

		this.state = {
			'isOpen': false,
			'loaded': true
		};
	}

	SearchMenu.prototype.componentDidMount = function componentDidMount() {
		document.addEventListener('click', this.onDocumentClick);
	};

	SearchMenu.prototype.componentWillUnmount = function componentWillUnmount() {
		document.removeEventListener('click', this.onDocumentClick);
	};

	SearchMenu.prototype.render = function render() {
		var _classNames,
		    _this2 = this;

		var styles = require('./SearchMenu.css');

		/* Classes for all nav elements contained here */
		var toggleStyles = _classnames2['default']((_classNames = {}, _classNames[styles.Toggle] = true, _classNames[styles['Toggle--here']] = this.state.isOpen, _classNames));

		return _react2['default'].createElement(
			'nav',
			{ className: (this.props.className ? this.props.className + ' ' : null) + styles.Nav },
			_react2['default'].createElement(
				'a',
				{ className: toggleStyles, href: '#', ref: 'toggle' },
				_react2['default'].createElement('i', { className: styles.ToggleIcon }),
				'Search'
			),
			this.state.isOpen && _react2['default'].createElement(
				'div',
				{ className: styles.Menu, ref: 'menu' },
				_react2['default'].createElement(_components.SearchField, { onSearch: function () {
						_this2.setState({ 'isOpen': false });
					} })
			)
		);
	};

	return SearchMenu;
})(_react2['default'].Component);

exports['default'] = SearchMenu;

SearchMenu.defaultProps = {
	'label': 'Label me!'
};

SearchMenu.propTypes = {
	'links': _react2['default'].PropTypes.array,
	'className': _react2['default'].PropTypes.string,
	'selected': _react2['default'].PropTypes.string
};
module.exports = exports['default'];
}.call(window));


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/SearchMenu/SearchMenu.js
 ** module id = 691
 ** module chunks = 0
 **/